const getUserPreferenceData = state => state?.userPreferenceData?.userPreferenceData


const selectors = {
    getUserPreferenceData
}

export default selectors